import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { APP_PREFIX } from '../constants';

export const useBroadcastRouteToParent = (eventName = 'child:navigate') => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        window.dispatchEvent(
            new CustomEvent(eventName, { detail: { path, basename: APP_PREFIX } })
        );
    }, [location.pathname, eventName]);
};
